/* HNS CUSTOM LAYER v2026.09.27 — Sense upgrade-safe. */
(() => {
  const HNS_VERSION = '2026.09.27';
  document.documentElement.dataset.hnsLayer = HNS_VERSION;

  const readAccountLabels = () => {
    const source = document.getElementById('hns-account-i18n');
    if (!source) return null;
    try {
      const labels = JSON.parse(source.textContent || '{}');
      const required = ['customerAccount', 'customerAccountLinks', 'profile', 'bookings', 'bookOnline', 'searchTest'];
      return required.every((key) => typeof labels[key] === 'string' && labels[key].trim()) ? labels : null;
    } catch (error) {
      console.warn('[HNS] Account-menu localization config is invalid.', error);
      return null;
    }
  };

  const replaceTag = (node, tagName) => {
    if (!node || node.tagName.toLowerCase() === tagName.toLowerCase()) return node;
    const replacement = document.createElement(tagName);
    for (const attribute of node.attributes) replacement.setAttribute(attribute.name, attribute.value);
    replacement.innerHTML = node.innerHTML;
    node.replaceWith(replacement);
    return replacement;
  };

  const markLcpImage = (img) => {
    if (!(img instanceof HTMLImageElement)) return;
    img.loading = 'eager';
    img.setAttribute('fetchpriority', 'high');
    if ('fetchPriority' in img) img.fetchPriority = 'high';
    img.dataset.hnsLcpPriority = 'high';
  };

  const prioritizeLcpImage = () => {
    const main = document.querySelector('main[data-template]');
    if (!main) return;

    const template = main.dataset.template;
    const selectorsByTemplate = {
      product: [
        '.product__media-list .product__media-item:first-child img',
        '.product__media-list li:first-child img',
        '.product__media img'
      ],
      article: [
        '.article-template__hero-container img',
        '.article-template__hero-adapt img',
        '.article-template img'
      ],
      collection: [
        '.collection-hero__image-container img',
        '#product-grid .grid__item:first-child img',
        '.product-grid .grid__item:first-child img'
      ],
      index: [
        '.hns-home-hero__image',
        '.shopify-section:first-child .banner__media img',
        '.shopify-section:first-child .image-with-text__media img',
        '.shopify-section:first-child img'
      ]
    };

    for (const selector of selectorsByTemplate[template] || []) {
      const img = main.querySelector(selector);
      if (!img) continue;
      markLcpImage(img);
      break;
    }
  };

  const enhanceAccountMenu = (root = document) => {
    const labels = readAccountLabels();
    if (!labels) return;

    root.querySelectorAll?.('shopify-account.header__icon--account').forEach((account) => {
      const iconMarkup = account.querySelector('.svg-wrapper')?.innerHTML || '';
      const details = document.createElement('details');
      details.className = 'hns-account-menu';
      details.innerHTML = `
        <summary class="header__icon header__icon--account link focus-inset hns-account-menu__trigger" aria-label="${labels.customerAccount}">
          <span class="svg-wrapper" aria-hidden="true">${iconMarkup}</span>
          <span class="visually-hidden">${labels.customerAccount}</span>
        </summary>
        <div class="hns-account-menu__panel">
          <nav class="hns-account-menu__nav" aria-label="${labels.customerAccountLinks}">
            <a href="https://shopify.com/72081867039/account/profile" target="_top"><span>${labels.profile}</span><span aria-hidden="true">→</span></a>
            <a href="https://shopify.com/72081867039/account" target="_top"><span>${labels.bookings}</span><span aria-hidden="true">→</span></a>
            <a href="/collections" target="_top"><span>${labels.bookOnline}</span><span aria-hidden="true">→</span></a>
            <a href="/search" target="_top"><span>${labels.searchTest}</span><span aria-hidden="true">→</span></a>
          </nav>
        </div>`;
      account.replaceWith(details);
    });
  };

  const normalize = (root = document) => {
    root.querySelectorAll?.('.rte h1, .product-popup-modal__content-info > h1.h2').forEach((node) => replaceTag(node, 'h2'));

    root.querySelectorAll?.('.why-pune__features[role="list"]').forEach((node) => {
      node.removeAttribute('role');
      node.removeAttribute('aria-label');
    });
    root.querySelectorAll?.('.why-pune__feature[role="listitem"]').forEach((node) => node.removeAttribute('role'));

    if (document.querySelector('main[data-template="index"]')) {
      document.querySelectorAll('h1.header__heading').forEach((node) => replaceTag(node, 'div'));
      const heroHeading = document.querySelector('main[data-template="index"] .hns-home-hero__title, main[data-template="index"] .image-with-text__heading');
      if (heroHeading && heroHeading.tagName !== 'H1') replaceTag(heroHeading, 'h1');
    }

    prioritizeLcpImage();
    enhanceAccountMenu(root);
  };

  const closeAccountMenus = (except = null) => {
    document.querySelectorAll('.hns-account-menu[open]').forEach((menu) => {
      if (menu !== except) menu.removeAttribute('open');
    });
  };

  document.addEventListener('click', (event) => {
    const activeMenu = event.target instanceof Element ? event.target.closest('.hns-account-menu') : null;
    if (!activeMenu) closeAccountMenus();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.hns-account-menu[open]').forEach((menu) => {
      menu.removeAttribute('open');
      menu.querySelector('summary')?.focus();
    });
  });

  document.addEventListener('toggle', (event) => {
    const menu = event.target;
    if (!(menu instanceof HTMLDetailsElement) || !menu.classList.contains('hns-account-menu') || !menu.open) return;
    closeAccountMenus(menu);
  }, true);

  /* Run as soon as the DOM is usable. The head preload handles parser-time product priority. */
  const init = () => normalize();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  let observerQueued = false;
  const observer = new MutationObserver((mutations) => {
    if (!mutations.some((mutation) => mutation.addedNodes.length)) return;
    if (observerQueued) return;

    observerQueued = true;
    window.requestAnimationFrame(() => {
      observerQueued = false;
      normalize();
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
